import {
	ICrudApplyProductAttrFilters,
	ICrudApplyProductAttrFiltersRes,
	ICrudApplyProductAttrIndividual,
	ICrudApplyProductAttrIndividualRes,
	ICrudProductAttrGlobalAssign,
	ICrudProductAttrGlobalAssignConfirm,
	ICrudProductAttrGlobalAssignConfirmRes,
	ICrudProductAttrGlobalAssignEdit,
	ICrudProductAttrGlobalAssignEditRes,
	ICrudProductAttrGlobalAssignPaginate,
	ICrudProductAttrGlobalAssignPaginateRes,
	ICrudProductAttrGlobalAssignResponse
} from 'models/ProductGlobalUploadInterface'
import {
	CLEAR_PRODUCTS_ATTR_GLOBAL,
	EDIT_PRODUCT_ATTR_GLOBAL_ASSIGN,
	EDIT_PRODUCT_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
	SET_PRODUCT_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_PRODUCT_ATTR_GLOBAL_FILTERS,
	SET_PRODUCT_ATTR_GLOBAL_FILTERS_SUCCESS,
	SET_PRODUCT_ATTR_INDIVIDUAL,
	SET_PRODUCT_ATTR_INDIVIDUAL_SUCCESS
} from '../constants/ActionsTypes'

export const productAttrGlobalApply = (
	payload: ICrudApplyProductAttrFilters
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_FILTERS,
		payload
	}
}

export const productAttrGlobalApplySuccess = (
	payload: ICrudApplyProductAttrFiltersRes
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_FILTERS_SUCCESS,
		payload
	}
}
export const productAttrIndividualApply = (
	payload: ICrudApplyProductAttrIndividual
) => {
	return {
		type: SET_PRODUCT_ATTR_INDIVIDUAL,
		payload
	}
}

export const productAttrIndividualApplySuccess = (
	payload: ICrudApplyProductAttrIndividualRes
) => {
	return {
		type: SET_PRODUCT_ATTR_INDIVIDUAL_SUCCESS,
		payload
	}
}
export const productAttrGlobalAssignConfirm = (
	payload: ICrudProductAttrGlobalAssignConfirm
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_ASSIGN_CONFIRM,
		payload
	}
}

export const productAttrGlobalAssignConfirmSuccess = (
	payload: ICrudProductAttrGlobalAssignConfirmRes
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
		payload
	}
}
export const productAttrGlobalAssignEdit = (
	payload: ICrudProductAttrGlobalAssignEdit
) => {
	return {
		type: EDIT_PRODUCT_ATTR_GLOBAL_ASSIGN,
		payload
	}
}

export const productAttrGlobalAssignEditRes = (
	payload: ICrudProductAttrGlobalAssignEditRes
) => {
	return {
		type: EDIT_PRODUCT_ATTR_GLOBAL_ASSIGN_SUCCESS,
		payload
	}
}
export const productAttrGlobalAssign = (
	payload: ICrudProductAttrGlobalAssign
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_ASSIGN,
		payload
	}
}

export const productAttrGlobalAssignSuccess = (
	payload: ICrudProductAttrGlobalAssignResponse
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_ASSIGN_SUCCESS,
		payload
	}
}
export const productAttrGlobalAssignPaginate = (
	payload: ICrudProductAttrGlobalAssignPaginate
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_ASSIGN_PAGINATION,
		payload
	}
}

export const productAttrGlobalAssignPaginateSuccess = (
	payload: ICrudProductAttrGlobalAssignPaginateRes
) => {
	return {
		type: SET_PRODUCT_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
		payload
	}
}
export const productCleanButton = () => ({
	type: CLEAR_PRODUCTS_ATTR_GLOBAL
})
